import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff, Trash2, Check } from 'lucide-react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const SetupModeration = () => {
  const [setups, setSetups] = useState([]);
  const [loading, setLoading] = useState(true);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const navigate = useNavigate();

  useEffect(() => {
    fetchSetups();
  }, []);

  const fetchSetups = async () => {
    try {
      const response = await axios.get(`${backendUrl}/api/admin/setups`, { withCredentials: true });
      setSetups(response.data);
    } catch (error) {
      toast.error('Ошибка загрузки сетапов');
    } finally {
      setLoading(false);
    }
  };

  const handleModerate = async (setupId, action) => {
    try {
      await axios.put(`${backendUrl}/api/admin/setups/${setupId}/moderate`, { action }, { withCredentials: true });
      toast.success('Сетап обновлён');
      fetchSetups();
    } catch (error) {
      toast.error('Ошибка модерации');
    }
  };

  return (
    <Card className="bg-[#1a1a1a] border-gray-800">
      <CardHeader>
        <CardTitle className="text-white">Модерация сетапов</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <p className="text-gray-400">Загрузка...</p>
        ) : setups.length === 0 ? (
          <p className="text-gray-400">Нет сетапов</p>
        ) : (
          <div className="space-y-3">
            {setups.map((setup) => (
              <div key={setup.id} className="bg-[#0a0a0a] border border-gray-800 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="text-white font-semibold">{setup.title || 'Без названия'}</h3>
                      {setup.is_public ? (
                        <span className="text-xs px-2 py-1 rounded bg-green-900/30 text-green-400 flex items-center gap-1">
                          <Eye className="h-3 w-3" />Публичный
                        </span>
                      ) : (
                        <span className="text-xs px-2 py-1 rounded bg-gray-700 text-gray-400 flex items-center gap-1">
                          <EyeOff className="h-3 w-3" />Приватный
                        </span>
                      )}
                      <span className="text-xs px-2 py-1 rounded bg-blue-900/30 text-blue-400">{setup.status}</span>
                    </div>
                    <p className="text-sm text-gray-400">Пользователь: {setup.user_id}</p>
                    <p className="text-sm text-gray-500">Шагов: {setup.steps?.length || 0} | Баланс: ${setup.initial_balance}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Button size="sm" variant="outline" onClick={() => navigate(`/setup/${setup.id}`)} className="border-gray-700 text-gray-300 hover:bg-gray-800">
                      Открыть
                    </Button>
                    {setup.is_public && (
                      <Button size="sm" variant="outline" onClick={() => handleModerate(setup.id, 'make_private')} className="border-yellow-900 text-yellow-400 hover:bg-yellow-900/20">
                        <EyeOff className="h-4 w-4" />
                      </Button>
                    )}
                    {!setup.is_public && (
                      <Button size="sm" variant="outline" onClick={() => handleModerate(setup.id, 'approve')} className="border-green-900 text-green-400 hover:bg-green-900/20">
                        <Check className="h-4 w-4" />
                      </Button>
                    )}
                    <Button size="sm" variant="outline" onClick={() => handleModerate(setup.id, 'reject')} className="border-red-900 text-red-400 hover:bg-red-900/20">
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SetupModeration;